export const logoTitleSizeStyle = 'text-s';
//# sourceMappingURL=logoTitleSizeStyle.js.map